<template>
    <div id="main-page" :class="mainPageClass">
        <div id="left-menu-container" :class="leftMenuContainerClass" v-if="!delegateLoading">
            <left-menu ref="leftMenu" @itemClicked="onLeftMenuItemClicked"></left-menu>
        </div>
        <div id="left-menu-collapsed-container" v-if="getResponsiveState != 1 && !delegateLoading">
            <img class="left-menu-opener" src="../assets/menu.svg" width="32px" @click="onLeftMenuOpenerClick"/>
            <p class="page-title-for-collapsed-state">{{pageTitle}}</p>
            <img class="left-menu-image-for-collapsed-state" src="../assets/valkyrie_logo_head.png">
        </div>
        <div :class="contentContainerClass" v-blur="blur" v-if="!delegateLoading">
            <verdict-search ref="verdictSearchBar" @onVerdictSearchHandler="onVerdictSearchHandler"></verdict-search>
            <dashboard v-if="selectedPageNumber == pageNumbers.DASHBOARD.number" ref="content"
                       v-show="!loading && !isIframeVisible" @loading="onLoading"
                       @loaded="onLoaded"></dashboard>
            <threat-score v-if="pageNumbers.N_THREAT_SCORE.number === selectedPageNumber"></threat-score>

            <stolen-passwords
                v-else-if="[pageNumbers.N_STOLEN_PASSWORD_DIRECT_CLIENT.number,pageNumbers.PA_STOLEN_PASSWORD_DIRECT.number].includes(selectedPageNumber)"
                :hidePasswordColumn="checkPasswordVisibilty()"
                :isDirect="true" :isClient="true" v-show="!loading && !isIframeVisible"
                @loading="onLoading" @loaded="onLoaded"
                :incomingThreatPageType="getThreatPageType(selectedPageNumber)"></stolen-passwords>
            <stolen-passwords
                v-else-if="[pageNumbers.N_STOLEN_PASSWORD_DIRECT_EMPLOYEE.number,pageNumbers.PA_STOLEN_PASSWORD_EMPLOYEE.number].includes(selectedPageNumber)"
                :hidePasswordColumn="checkPasswordVisibilty()" :isDirect="true" :isClient="false"
                v-show="!loading && !isIframeVisible"
                @loading="onLoading" @loaded="onLoaded"
                :incomingThreatPageType="getThreatPageType(selectedPageNumber)"></stolen-passwords>
            <stolen-passwords
                v-else-if="[pageNumbers.N_STOLEN_PASSWORD_3RD.number,pageNumbers.PA_STOLEN_PASSWORD_3RD.number].includes(selectedPageNumber)"
                :hidePasswordColumn="checkPasswordVisibilty()" :isDirect="false" v-show="!loading && !isIframeVisible"
                @loading="onLoading" @loaded="onLoaded"
                :incomingThreatPageType="getThreatPageType(selectedPageNumber)"></stolen-passwords>

            <targeted-malware
                v-if="[pageNumbers.N_TARGETED_MALWARE.number, pageNumbers.GL_TARGETED_MALWARE.number, pageNumbers.PA_TARGETED_MALWARE.number, pageNumbers.IN_TARGETED_MALWARE.number].includes(selectedPageNumber)"
                v-show="!loading && !isIframeVisible"
                :incomingThreatPageType="getThreatPageType(selectedPageNumber)"
                @loading="onLoading"
                @loaded="onLoaded"
                @onVerdictSearchHandler="onVerdictSearchHandler"
            ></targeted-malware>

            <targeted-phishing-site
                v-if="[pageNumbers.N_TARGETED_PHISHING_SITE.number, pageNumbers.GL_TARGETED_PHISHING_SITE.number, pageNumbers.PA_TARGETED_PHISHING_SITE.number, pageNumbers.IN_TARGETED_PHISHING_SITE.number].includes(selectedPageNumber)"
                v-show="!loading && !isIframeVisible"
                :incomingThreatPageType="getThreatPageType(selectedPageNumber)"
                @loading="onLoading"
                @loaded="onLoaded"
                @onVerdictSearchHandler="onVerdictSearchHandler"
            ></targeted-phishing-site>

            <targeted-phishing-email
                v-if="[pageNumbers.N_TARGETED_PHISHING_EMAIL.number, pageNumbers.GL_TARGETED_PHISHING_EMAIL.number, pageNumbers.PA_TARGETED_PHISHING_EMAIL.number, pageNumbers.IN_TARGETED_PHISHING_EMAIL.number].includes(selectedPageNumber)"
                v-show="!loading && !isIframeVisible"
                :incomingThreatPageType="getThreatPageType(selectedPageNumber)"
                @loading="onLoading"
                @loaded="onLoaded"
                @onVerdictSearchHandler="onVerdictSearchHandler"
            ></targeted-phishing-email>

            <malware-hosting
                v-if="[pageNumbers.N_MALWARE_HOSTING.number, pageNumbers.GL_MALWARE_HOSTING.number, pageNumbers.PA_MALWARE_HOSTING.number, pageNumbers.IN_MALWARE_HOSTING.number].includes(selectedPageNumber)"
                v-show="!loading && !isIframeVisible"
                :incomingThreatPageType="getThreatPageType(selectedPageNumber)"
                @loading="onLoading"
                @loaded="onLoaded"
                @onVerdictSearchHandler="onVerdictSearchHandler"
            ></malware-hosting>


            <deceptive-phishing-hosting
                v-if="[pageNumbers.N_DECEPTIVE_PHISHING_HOSTING.number, pageNumbers.GL_DECEPTIVE_PHISHING_HOSTING.number, pageNumbers.PA_DECEPTIVE_PHISHING_HOSTING.number, pageNumbers.IN_DECEPTIVE_PHISHING_HOSTING.number].includes(selectedPageNumber)"
                v-show="!loading && !isIframeVisible"
                :incomingThreatPageType="getThreatPageType(selectedPageNumber)"
                @loading="onLoading"
                @loaded="onLoaded"
                @onVerdictSearchHandler="onVerdictSearchHandler"
            ></deceptive-phishing-hosting>

            <cc-hosting
                v-if="[pageNumbers.N_C_C_HOSTING.number, pageNumbers.GL_C_C_HOSTING.number, pageNumbers.PA_C_C_HOSTING.number, pageNumbers.IN_C_C_HOSTING.number].includes(selectedPageNumber)"
                v-show="!loading && !isIframeVisible"
                :incomingThreatPageType="getThreatPageType(selectedPageNumber)"
                @loading="onLoading"
                @loaded="onLoaded"
                @onVerdictSearchHandler="onVerdictSearchHandler"
            ></cc-hosting>

            <phishing-received
                v-if="[pageNumbers.N_PHISHING_RECEIVED.number, pageNumbers.GL_PHISHING_RECEIVED.number, pageNumbers.PA_PHISHING_RECEIVED.number, pageNumbers.IN_PHISHING_RECEIVED.number].includes(selectedPageNumber)"
                v-show="!loading && !isIframeVisible"
                :incomingThreatPageType="getThreatPageType(selectedPageNumber)"
                @loading="onLoading"
                @loaded="onLoaded"
                @onVerdictSearchHandler="onVerdictSearchHandler"
            ></phishing-received>

            <botnet-member
                v-if="[pageNumbers.N_BOTNET_MEMBER.number, pageNumbers.GL_BOTNET_MEMBER.number, pageNumbers.PA_BOTNET_MEMBER.number, pageNumbers.IN_BOTNET_MEMBER.number].includes(selectedPageNumber)"
                v-show="!loading && !isIframeVisible"
                :incomingThreatPageType="getThreatPageType(selectedPageNumber)"
                @loading="onLoading"
                @loaded="onLoaded"
                @onVerdictSearchHandler="onVerdictSearchHandler"
            ></botnet-member>

            <targeted-software
                v-if="[pageNumbers.N_TARGETED_SOFTWARE.number, pageNumbers.GL_TARGETED_SOFTWARE.number, pageNumbers.PA_TARGETED_SOFTWARE.number, pageNumbers.IN_TARGETED_SOFTWARE.number].includes(selectedPageNumber)"
                v-show="!loading && !isIframeVisible"
                :incomingThreatPageType="getThreatPageType(selectedPageNumber)"
                @loading="onLoading"
                @loaded="onLoaded"
                @onVerdictSearchHandler="onVerdictSearchHandler"
            ></targeted-software>

            <spam-sender
                v-if="[pageNumbers.N_SPAM_SENDER.number, pageNumbers.GL_SPAM_SENDER.number, pageNumbers.PA_SPAM_SENDER.number, pageNumbers.IN_SPAM_SENDER.number].includes(selectedPageNumber)"
                v-show="!loading && !isIframeVisible"
                :incomingThreatPageType="getThreatPageType(selectedPageNumber)"
                @loading="onLoading"
                @loaded="onLoaded"
                @onVerdictSearchHandler="onVerdictSearchHandler"
            ></spam-sender>

            <drop-sites
                v-if="[pageNumbers.N_DROP_SITES_FOR_LOGS_OR_STOLEN_CREDENTIALS.number, pageNumbers.GL_DROP_SITES_FOR_LOGS_OR_STOLEN_CREDENTIALS.number, pageNumbers.PA_DROP_SITES_FOR_LOGS_OR_STOLEN_CREDENTIALS.number, pageNumbers.IN_DROP_SITES_FOR_LOGS_OR_STOLEN_CREDENTIALS.number].includes(selectedPageNumber)"
                v-show="!loading && !isIframeVisible"
                :incomingThreatPageType="getThreatPageType(selectedPageNumber)"
                @loading="onLoading"
                @loaded="onLoaded"
                @onVerdictSearchHandler="onVerdictSearchHandler"
            ></drop-sites>

            <known-compromised
                v-if="[pageNumbers.N_KNOWN_COMPROMISED_HOSTILE_SERVERS.number, pageNumbers.GL_KNOWN_COMPROMISED_HOSTILE_SERVERS.number, pageNumbers.PA_KNOWN_COMPROMISED_HOSTILE_SERVERS.number, pageNumbers.IN_KNOWN_COMPROMISED_HOSTILE_SERVERS.number].includes(selectedPageNumber)"
                v-show="!loading && !isIframeVisible"
                :incomingThreatPageType="getThreatPageType(selectedPageNumber)"
                @loading="onLoading"
                @loaded="onLoaded"
                @onVerdictSearchHandler="onVerdictSearchHandler"
            ></known-compromised>

            <pua-hosting
                v-if="[pageNumbers.N_PUA_HOSTING.number, pageNumbers.GL_PUA_HOSTING.number, pageNumbers.PA_PUA_HOSTING.number, pageNumbers.IN_PUA_HOSTING.number].includes(selectedPageNumber)"
                v-show="!loading && !isIframeVisible"
                :incomingThreatPageType="getThreatPageType(selectedPageNumber)"
                @loading="onLoading"
                @loaded="onLoaded"
                @onVerdictSearchHandler="onVerdictSearchHandler"
            ></pua-hosting>
            <settings v-if="selectedPageNumber == pageNumbers.SETTINGS.number" v-show="!loading && !isIframeVisible"
                      @loading="onLoading" @loaded="onLoaded"
                      :isPhoneModalGoToSettingsClicked="isPhoneModalGoToSettingsClicked"></settings>

            <verdict-and-killchain v-if="isIframeVisible" v-show="!loading" @loading="onLoading"
                                   @loaded="onLoaded"
                                   @backButtonHandlerMainPage="backButtonHandlerMainPage"
                                   @clearVerdictSearchBar="clearVerdictSearchBar"></verdict-and-killchain>
        </div>
        <div v-if="leftMenuOpen" class="collapsed-left-menu-overlay" @click="onOverlayClick"></div>
        <phone-number-not-exist-modal @goToAccountPage="goToAccountPage"
                                      ref="phoneNumberNotExistModal"></phone-number-not-exist-modal>
        <loading-modal v-if="delegateLoading"></loading-modal>
        <forgotPassword-modal ref="forgotPasswordModal"></forgotPassword-modal>
        <faq-modal ref="faqModal"></faq-modal>
        <feedback-modal ref="feedbackModal"></feedback-modal>

    </div>
</template>

<script>

    import Common from '@/utils/Common.vue'
    import LeftMenu from '@/components/left-menu/LeftMenu.vue'
    import LoadingModal from '@/components/modals/LoadingModal.vue'
    import PhoneNumberNotExistModal from '@/components/modals/PhoneNumberNotExistModal.vue'
    import ForgotPasswordModal from '@/components/modals/ForgotPasswordModal.vue'
    import FaqModal from '@/components/modals/FaqModal.vue'
    import FeedbackModal from '@/components/modals/FeedbackModal.vue'
    import VerdictSearch from '@/components/verdict-search/VerdictSearch.vue'

    // Pages
    import Dashboard from '@/pages/dashboard-page/DashboardPage.vue'
    import ThreatScore from '@/pages/ThreatScore.vue'
    import TargetedMalware from '@/pages/TargetedMalware.vue'
    import StolenPasswords from '@/pages/StolenPasswords.vue'
    import TargetedPhishingSite from '@/pages/TargetedPhishingSite.vue'
    import TargetedPhishingEmail from '@/pages/TargetedPhishingEmail.vue'

    import MalwareHosting from '@/pages/MalwareHosting.vue'
    import DeceptivePhishingHosting from '@/pages/DeceptivePhishingHosting.vue'
    import CCHosting from '@/pages/CCHosting.vue'
    import PhishingReceived from '@/pages/PhishingReceived.vue'
    import BotnetMember from '@/pages/BotnetMember.vue'
    import TargetedSoftware from '@/pages/TargetedSoftware.vue'
    import SpamSender from '@/pages/SpamSender.vue'
    import DropSites from '@/pages/DropSites.vue'
    import KnownCompromised from '@/pages/KnownCompromised.vue'
    import PuaHosting from '@/pages/PuaHosting.vue'
    import TargetedPhishing from "./dashboard-page/targeted-phishing/TargetedPhishing";
    import CcHosting from "./CCHosting";
    import VerdictAndKillchain from "./VerdictAndKillchain"

    // import Settings from "./Settings";
    import Constants from '@/utils/constants'
    import Settings from '@/pages/Settings.vue'
    import PageNumbers from '@/utils/page-number-constants';

    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';

    export default {
        name: "main-page",
        components: {
            ThreatScore: ThreatScore,
            CcHosting,
            TargetedPhishing,
            LoadingModal: LoadingModal,
            LeftMenu: LeftMenu,
            Dashboard: Dashboard,
            TargetedMalware: TargetedMalware,
            StolenPasswords: StolenPasswords,
            TargetedPhishingSite: TargetedPhishingSite,
            TargetedPhishingEmail: TargetedPhishingEmail,
            DeceptivePhishingHosting: DeceptivePhishingHosting,
            MalwareHosting: MalwareHosting,
            CCHosting: CCHosting,
            PhishingReceived: PhishingReceived,
            BotnetMember: BotnetMember,
            TargetedSoftware: TargetedSoftware,
            SpamSender: SpamSender,
            DropSites: DropSites,
            KnownCompromised: KnownCompromised,
            PuaHosting: PuaHosting,
            Settings: Settings,
            ForgotPasswordModal: ForgotPasswordModal,
            FaqModal: FaqModal,
            FeedbackModal: FeedbackModal,
            VerdictSearch: VerdictSearch,
            VerdictAndKillchain: VerdictAndKillchain,
            PhoneNumberNotExistModal: PhoneNumberNotExistModal
        },
        mixins: [Common],
        data() {
            return {
                pageNumbers: PageNumbers,
                width: 0,
                selectedPageNumber: PageNumbers.DASHBOARD.number,
                leftMenuOpen: false,
                loading: false,
                delegateLoading: false,
                whitelabeling_configuration_data: {},
                whitelabeling_login_configuration_data: {},
                isPhoneModalGoToSettingsClicked: false
            }
        },
        methods: {
            changeIsPhoneModalGoToSettingsClicked() {
                this.isPhoneModalGoToSettingsClicked = false;
            },
            goToAccountPage() {
                this.$refs.phoneNumberNotExistModal.hideModal();
                this.isPhoneModalGoToSettingsClicked = true;
                this.setIsPhoneModalDisplayed(true);
                this.loading = false;
                this.selectedPageNumber = -1;
                this.setSelectedPageNumber(-1);
                this.$nextTick(function () {
                    this.selectedPageNumber = this.pageNumbers.SETTINGS.number;
                    this.setSelectedPageNumber(this.pageNumbers.SETTINGS.number);
                    this.$router.push(this.getPagePath(this.pageNumbers.SETTINGS.number));
                });
            },
            checkPhoneNumberModal() {
                if (this.isPhoneModalOpen && !this.getIsPhoneModalDisplayed) {
                    setTimeout(() => {
                        this.$refs.phoneNumberNotExistModal.showModal();
                    }, 2000);
                }
            },
            onWindowResize() {
                this.width = $(window).width();
                this.calculateResponsiveState();
            },
            calculateResponsiveState() {
                var responsiveState;
                if (this.width > 1600) {
                    responsiveState = this.RESPONSIVE_BIG;
                    this.leftMenuOpen = false;
                } else if (this.width <= 1600 && this.width >= 1280) {
                    responsiveState = this.RESPONSIVE_MIDDLE;
                } else {
                    responsiveState = this.RESPONSIVE_SMALL;
                }
                this.setResponsiveState(responsiveState);
            },
            backButtonHandlerMainPage() {
                this.setIsIframeVisible(false);
            },
            clearVerdictSearchBar() {
                this.$refs.verdictSearchBar.$refs.verdictSearchValue.value = "";
            },
            onVerdictSearchHandler(searchString, component, pageName, comingFromSearchBar) {
                this.verdictSearchHandlerCommon(searchString, component, pageName, comingFromSearchBar);
            },
            onLeftMenuItemClicked(item) {
                this.setIsIframeVisible(false);
                if (item.pageNumber != 'support') {
                    this.loading = false;
                    this.selectedPageNumber = -1;
                    this.setSelectedPageNumber(-1);
                    this.$nextTick(function () {
                        this.selectedPageNumber = item.pageNumber;
                        this.setSelectedPageNumber(item.pageNumber);
                        this.setSelectedPage(item);
                        this.$router.push(this.getPagePath(item.pageNumber));
                    });

                    if (this.leftMenuOpen)
                        this.leftMenuOpen = false;
                } else {
                    if (item.order < 3) {
                        window.open(item.redirect, '_blank');
                    } else if (item.order === 3) {
                        this.$refs.feedbackModal.showModal();
                    } else {
                        this.$refs.faqModal.showModal();
                    }

                    this.saveLog(this, 'Left Menu - Support', item.logText, null, null);
                }
            },
            onLeftMenuOpenerClick() {
                this.leftMenuOpen = !this.leftMenuOpen;
            },
            onOverlayClick() {
                this.leftMenuOpen = false;
            },
            onLoading() {
                this.loading = true;
            },
            onLoaded() {
                this.loading = false;
            },
            getResourceURL() {
                var path = Constants.INTELLIGENCE_BACKEND_URL + '/get_resources_url';
                this.$http.get(path)
                    .then(response => {
                        this.resourceURL = response.data.resource_url;
                        this.setResourceURL(this.resourceURL);
                        this.loading = false;
                    }, response => {
                        this.loading = false;
                    });
            },
            getPlatformKillChainEndPointFromBackend() {
                var path = Constants.INTELLIGENCE_BACKEND_URL + '/platform/kill_chain/endpoint';
                this.$http.get(path).then(response => {
                    this.setPlatformKillChainEndPoint(response.body);
                }, response => {

                })
            },
            checkDelegatedLogin() {
                this.delegateLoading = true;
                var query = this.$route.query;
                let url = window.location.href;
                let parse_url = url.split("?");
                if (query.username) {
                    var user = {
                        'username': query.username
                    };
                    var promise = this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/delegate_login?session_id=' + query.session_id +
                        "&man_session_id=" + query.man_session_id, user);
                    promise.then(result => {
                        var authorized = this.setUserInformation(result);
                        this.whitelabeling_login_configuration_data = result.data.whitelabeling_configuration;
                        this.setWhiteLabelingData(this.whitelabeling_login_configuration_data);
                        this.checkPhoneNumberModal();
                        if (authorized) {
                            this.$router.push("/");
                            this.getResourceURL();
                        } else {
                            this.$router.push("/login");
                        }
                        this.delegateLoading = false;
                    }, result => {
                        this.$router.push("/login");
                    });
                } else {
                    this.checkPhoneNumberModal();
                }
            },
            checkPasswordVisibilty() {
                let hidePassword = false;
                if (this.getUserRole(this.getComodoAdminRole) == "TI_VI_MSSP_USER")
                    hidePassword = true;

                return hidePassword;
            },
            ...mapActions([
                "setResponsiveState",
                "setSelectedPageNumber",
                "setSelectedPage",
                "setResourceURL",
                "setPlatformKillChainEndPoint",
                "setWhiteLabelingData",
                "setIsIframeVisible",
                "setIsPhoneModalDisplayed"
            ])
        },
        computed: {
            isIframeVisible() {
                return this.getIsIframeVisible;
            },
            isPhoneModalOpen() {
                return this.getComodoAdminRole === null && this.getUserPhoneNumber === null;
            },
            contentContainerClass() {
                if (this.getResponsiveState == this.RESPONSIVE_BIG) {
                    return "content-container-big";
                } else {
                    return "content-container-medium";
                }
            },
            leftMenuContainerClass() {
                if (this.getResponsiveState == this.RESPONSIVE_BIG) {
                    return "";
                } else {
                    if (this.leftMenuOpen) {
                        return "left-menu-container-collapsed-but-opened";
                    } else {
                        return "left-menu-container-collapsed";
                    }
                }
            },
            mainPageClass() {
                if (this.getResponsiveState == this.RESPONSIVE_BIG) {
                    return "main-page-big";
                } else {
                    return "main-page-middle";
                }
            },
            pageTitle() {
                if (this.selectedPageNumber == PageNumbers.DASHBOARD.number)
                    return "DASHBOARD";
                return "";
            },
            blur() {
                return {
                    isBlurred: this.leftMenuOpen,
                    opacity: 0.3,
                    filter: 'blur(4px)',
                    transition: 'all .3s linear'
                }
            },
            getCustomerLoginWhiteLabeling() {
                let path = Constants.INTELLIGENCE_BACKEND_URL + '/whitelabeling_by_enterprise_id';
                let body = {
                    enteprise_id: ''
                };
                this.$http.post(path, body).then(response => {
                    this.whitelabeling_login_configuration_data = response.body.data.whitelabeling_configuration;
                    this.setWhiteLabelingData(this.whitelabeling_login_configuration_data);
                }, response => {

                });
            },
            ...mapGetters([
                "getResponsiveState",
                "getPageNumber",
                "getComodoAdminRole",
                "getUserPhoneNumber",
                "getIsPhoneModalDisplayed",
                "getIsIframeVisible"
            ])
        },
        beforeMount() {
            this.checkDelegatedLogin();
            this.setIsIframeVisible(false);
        },
        mounted() {
            this.getPlatformKillChainEndPointFromBackend();
            var query = this.$route.query;
            if (!query.username) {
                this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/login_check')
                    .then(result => {
                        this.delegateLoading = false;
                        if (result.data.return_code == 'Unauthorized User') {
                            this.$router.push("/login");
                        }
                    }, result => {
                        this.delegateLoading = false;
                        this.$router.push("/login");
                    });
            }
            var self = this;
            self.onWindowResize();
            $(window).on('resize', self.onWindowResize);

            this.selectedPageNumber = this.getPageNumberFromPath(this.$route.path);
            this.setSelectedPageNumber(this.selectedPageNumber);
        },
        beforeDestroy() {
            var self = this;
            $(window).off("resize", self.onWindowResize);
        }
    }

</script>

<style>
    /**
    datetime css overrides start
     */
    .datetime-theme-black .vdatetime-month-picker__list::-webkit-scrollbar, .vdatetime-year-picker__list::-webkit-scrollbar {
        display: none;
    }

    .datetime-theme-black .vdatetime-input {
        display: none;
    }

    .datetime-theme-black .vdatetime-popup {
        position: absolute !important;
    }

    .datetime-theme-black .vdatetime-popup__header {
        background: #20272D !important;

    }

    .datetime-theme-black .vdatetime-popup__year{
        opacity: 1;
    }

    .datetime-theme-black .vdatetime-calendar__month__day--selected > span > span,
    .datetime-theme-black .vdatetime-calendar__month__day--selected:hover > span > span {
        background: #00FEAB !important;
    }

    .datetime-theme-black .vdatetime-month-picker__item--selected{
        color: #00FEAB !important;
    }

    .datetime-theme-black .vdatetime-popup {
        background: black;
        color: white;
    }

    .datetime-theme-black .vdatetime-calendar__month__day:hover > span > span {
        background: #00FEAB;
    }

    .datetime-theme-black .vdatetime-calendar__month__day--disabled:hover > span > span {
        background: black;
    }

    .datetime-theme-black .vdatetime-year-picker__item--selected,
    .datetime-theme-black .vdatetime-time-picker__item--selected,
    .datetime-theme-black .vdatetime-popup__actions__button {
        color: #00FEAB !important;
    }

    .datetime-theme-black .vdatetime-calendar__navigation--previous path, .vdatetime-calendar__navigation--next path {
        stroke: #ffffff;
    }
    /**
    datetime css overrides ends
    */

    #main-page {
        width: 100%;
        height: 100%;
        background-color: rgb(27, 33, 41);
        min-width: 800px;
        position: relative;
        overflow: hidden;
    }

    .main-page-big {
        padding: 20px;
    }

    .main-page-middle {
        padding: 20px;
    }

    #left-menu-container {
        padding: 0;
        height: calc(100% - 40px);
        max-height: 100%;
        width: 310px;
        left: 20px;
        overflow: hidden;
        position: absolute;
        transition: all 0.3s;
        opacity: 1;
        z-index: 2;
    }

    .left-menu-container-collapsed {
        left: -330px !important;
        top: 80px !important;
        transition: all 0.3s;
        opacity: 0;
    }

    .left-menu-container-collapsed-but-opened {
        left: 20px;
        top: 80px;
        opacity: 1;
        transition: all 0.3s;
        z-index: 5 !important;
    }

    #left-menu-collapsed-container {
        position: absolute;
        top: 10px;
        left: 20px;
        right: 20px;
        height: 60px;
        background-color: black;
    }

    .content-container-big {
        height: calc(100% - 40px);
        width: calc(100% - 370px);
        padding: 0;
        position: absolute;
        left: 350px;
        top: 20px;
        bottom: 20px;
        transition: all 0.3s;
    }

    .content-container-medium {
        height: calc(100% - 90px);
        width: calc(100% - 40px);
        padding: 0;
        transition: all 0.3s;
        position: absolute;
        top: 80px;
        left: 20px;
        right: 20px;
        bottom: 20px;
    }

    .left-menu-opener {
        position: absolute;
        left: 20px;
        top: 0;
        bottom: 0;
        margin: auto;
        cursor: pointer;
        z-index: 4;
    }

    .page-title-for-collapsed-state {
        position: absolute;
        line-height: 60px;
        color: white;
        top: 0;
        left: 70px;
        bottom: 0;
        font-size: 22px;
        font-family: 'Digital-Serial-Bold';
    }

    .collapsed-left-menu-overlay {
        position: absolute;
        top: 80px;
        left: 20px;
        right: 20px;
        bottom: 20px;
        height: calc(100% - 90px);
        width: calc(100% - 40px);
        background-color: transparent;
        z-index: 2;
        opacity: 0.4;
        transition: all 0.1s;
    }

    .left-menu-image-for-collapsed-state {
        position: absolute;
        width: 28px;
        top: 0;
        bottom: 0;
        left: calc(50% - 14px);
        margin: auto;
    }

    .pages {
        height: 100%;
    }

</style>



// WEBPACK FOOTER //
// src/pages/MainPage.vue